import React from 'react';
import { connect } from 'react-redux';
import BaseComponent from '../../../baseClasses/BaseComponent';
import WizardView from '../../../components/WizardView';
import dataModel from '../../../models/DataModel';
import CompanyDataCollector from '../CompanyDataCollector';
import './AddAffiliateCompanyWizard.scss';

export class AddAffiliateCompanyWizard extends BaseComponent {

  constructor(props) {
    super(props);
    this.state = {};

    this.createPage1 = this.createPage1.bind(this);

    this.state = {
      vendorCompanies: null,
    };
  }

  handleFinishOK() {
    const { vendorCompanies } = this.state;
    if (vendorCompanies) {
      for (let i = 0; i < vendorCompanies.length; i++) {
        let vendor_company = vendorCompanies[i];
        if (vendor_company.toBeAdded) {
          delete vendor_company.toBeAdded;
          dataModel.companiesDAO.createVendorCompany(vendor_company);
        }
        else if (vendor_company.toBeDeleted) {
          delete vendor_company.toBeDeleted;
          dataModel.companiesDAO.deleteVendorCompany(vendor_company);
        }
      }
    }
    const { handleWizardDone } = this.props;
    if (handleWizardDone) {
      handleWizardDone();
    }
  }

  handleOk() {
    this.handleFinishOK();
  }

  handleCancel() {
    const { handleWizardDone } = this.props;
    if (handleWizardDone) {
      handleWizardDone();
    }
  }

  handleSelectVendorCompanies(vendor_companies) {
    this.setState({ vendorCompanies: vendor_companies });
  }

  createPage1() {
    const companies = this.props.companies ? this.props.companies.filter(searchCompany => {
      return searchCompany.id != this.props.currentCompany.id;
    }) : [];
    return (
      <div className="add-company-main">
        <CompanyDataCollector id={'add-company-main'} title="" selectVendorCompanies={this.handleSelectVendorCompanies}
          type={'NONE'} isDialog={true} companies={companies} company={this.props.currentCompany}/>
      </div>
    );
  }

  render() {
    let pages = [
      { caption: '', contents: this.createPage1() },
    ];

    const { settingPopup } = this.state;

    const addCompanyWizard = {
      popupId: 'newCompany',
      caption: `Manage ${this.textMap.vendor} Companies`,
      height: 140,
      width: 376,
      pages: pages,
      handleOwnerDone: this.handleOk,
      handleOwnerCancel: this.handleCancel,
      currentUser: this.props.currentUser,
    };
    return (
      <div>
        <WizardView wizard={addCompanyWizard} />
        {settingPopup}
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    currentCompany: state.new_companies.currentCompany,
    permissions: state.new_users.permissions,
    userRoles: state.new_users.userRoles,
  };
};

// For handling state change from a dispatch
const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddAffiliateCompanyWizard);



// WEBPACK FOOTER //
// ./src/containers/CompaniesContainer/AddAffiliateCompanyWizard/index.js